











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingAvatar_teamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "2f681538751f1111fc4f0404901def6c";

export default node;
